export const getLineMeta = (text, selectionStart, selectionEnd) => {
  const lines = text.split("\n");
  const lineStarts = [];
  let offset = 0;
  for (let i = 0; i < lines.length; i += 1) {
    lineStarts.push(offset);
    offset += lines[i].length + 1;
  }

  let startLineIndex = 0;
  let endLineIndex = 0;
  for (let i = 0; i < lineStarts.length; i += 1) {
    if (lineStarts[i] <= selectionStart) {
      startLineIndex = i;
    }
    if (lineStarts[i] <= selectionEnd) {
      endLineIndex = i;
    }
  }

  return { lines, lineStarts, startLineIndex, endLineIndex };
};

export const formatAnimationScript = (source = "") => {
  const text = source.replace(/\r\n/g, "\n");
  const rawLines = [];
  let current = "";
  let inSingle = false;
  let inDouble = false;
  let inTemplate = false;
  let inLineComment = false;
  let inBlockComment = false;
  let escaped = false;

  const flush = () => {
    rawLines.push(current.trim());
    current = "";
  };

  for (let i = 0; i < text.length; i += 1) {
    const ch = text[i];
    const next = text[i + 1];

    if (inLineComment) {
      current += ch;
      if (ch === "\n") {
        inLineComment = false;
        flush();
      }
      continue;
    }

    if (inBlockComment) {
      current += ch;
      if (ch === "*" && next === "/") {
        current += "/";
        i += 1;
        inBlockComment = false;
      } else if (ch === "\n") {
        flush();
      }
      continue;
    }

    if (inSingle || inDouble || inTemplate) {
      current += ch;
      if (escaped) {
        escaped = false;
      } else if (ch === "\\") {
        escaped = true;
      } else if (inSingle && ch === "'") {
        inSingle = false;
      } else if (inDouble && ch === '"') {
        inDouble = false;
      } else if (inTemplate && ch === "`") {
        inTemplate = false;
      }
      continue;
    }

    if (ch === "/" && next === "/") {
      current += "//";
      i += 1;
      inLineComment = true;
      continue;
    }

    if (ch === "/" && next === "*") {
      current += "/*";
      i += 1;
      inBlockComment = true;
      continue;
    }

    if (ch === "'") {
      inSingle = true;
      current += ch;
      continue;
    }
    if (ch === '"') {
      inDouble = true;
      current += ch;
      continue;
    }
    if (ch === "`") {
      inTemplate = true;
      current += ch;
      continue;
    }

    if (ch === ";") {
      current += ch;
      let j = i + 1;
      while (j < text.length && (text[j] === " " || text[j] === "\t")) {
        current += text[j];
        j += 1;
      }
      if (text[j] === "/" && text[j + 1] === "/") {
        current += "//";
        i = j + 1;
        inLineComment = true;
        continue;
      }
      if (text[j] === "/" && text[j + 1] === "*") {
        current += "/*";
        i = j + 1;
        inBlockComment = true;
        continue;
      }
      flush();
      continue;
    }

    if (ch === "{" || ch === "}") {
      current += ch;
      flush();
      continue;
    }

    if (ch === "\n") {
      if (current && !/\s$/.test(current)) {
        current += " ";
      }
      continue;
    }

    current += ch;
  }

  if (current.trim()) {
    flush();
  }

  const lines = rawLines.filter((line) => line.length > 0);
  let depth = 0;
  return lines
    .map((line) => {
      const leadingClosers = (line.match(/^[\]\)\}]+/) || [""])[0].length;
      const effectiveDepth = Math.max(0, depth - leadingClosers);
      const formatted = `${"\t".repeat(effectiveDepth)}${line}`;
      const opens = (line.match(/\{/g) || []).length;
      const closes = (line.match(/\}/g) || []).length;
      depth = Math.max(0, depth + opens - closes);
      return formatted;
    })
    .join("\n");
};
